import * as React from 'react';

import { BreakpointSizeType } from '../../../../theme/type/breakpoints-type';
import { cn } from '../../../../utils/tailwind';

const mobileBreakUnderClass: Record<BreakpointSizeType, string> = {
    xs: 'hidden xs:table-header-group',
    vs: 'hidden vs:table-header-group',
    sm: 'hidden sm:table-header-group',
    md: 'hidden md:table-header-group',
    lg: 'hidden lg:table-header-group',
    vl: 'hidden vl:table-header-group',
    xl: 'hidden xl:table-header-group',
    xxl: 'hidden xxl:table-header-group',
    fullhd: 'hidden fullhd:table-header-group',
};

export interface TableHeadPropsInterface {
    children: React.ReactElement[] | React.ReactElement;
    mobileBreakUnder?: BreakpointSizeType;
    isScrolled?: boolean;
    isScrollable?: boolean;
    isScrollOnEnd?: boolean;
}

export const TableHead: React.FC<TableHeadPropsInterface> = ({
    children,
    mobileBreakUnder,
    isScrolled,
    isScrollable,
    isScrollOnEnd,
}) => {
    const variant = 'thead';
    const className = cn('border-0', mobileBreakUnder && mobileBreakUnderClass[mobileBreakUnder]);

    if (Array.isArray(children)) {
        return (
            <thead className={className}>
                {children.map((child, index: number) => {
                    return React.cloneElement(child, {
                        mobileBreakUnder,
                        variant,
                        isScrolled,
                        isScrollable,
                        isScrollOnEnd,
                        key: index,
                    });
                })}
            </thead>
        );
    }

    return (
        <thead className={className}>
            {React.cloneElement(children, {
                mobileBreakUnder,
                isScrolled,
                isScrollable,
                isScrollOnEnd,
                variant,
            })}
        </thead>
    );
};
